export default __webpack_public_path__ + "static/8203ae66aaf1d2729a6880b8430048ea.png";